import $ from "/js/libs/jquery-3.3.1.min.js"
import {gsap} from "/js/libs/gsap/all.js"
import {BaseGame} from '/js/app/base/BaseGame.js'

// Constructor
export class BaseGameCaChauffe extends BaseGame {

  constructor(dataFile = 'data/data.json') {

    // Super constructor
    super(dataFile);

    // Screensaver
    this.stillThereTimeout = false;
    this.screensaverDelay = 45; // Time before app return to idle screen

    this.upSince = Date.now();
  }

  // goToScreenSaver() {
  //
  //   if ($("#still-there").hasClass("active")) {
  //     return false;
  //   }
  //
  //   $("#still-there").addClass("active");
  //   this.openStillThereModal();
  //   this.stillThereTimeout = setTimeout(() => {
  //     this.reset(1);
  //     this.closeStillThereModal();
  //   }, this.screenRedirectDelay * 1000);
  // }

  openStillThereModal() {
    const tl = new gsap.timeline();

    tl.to($("#still-there"), 0.5, {
      autoAlpha: 1
    });
    tl.fromTo($("#still-there .modal"), 0.5, {
      autoAlpha: 0,
      y: "-10px",
    }, {
      autoAlpha: 1,
      y: 0,
    });
  }

  closeStillThereModal() {

    if (this.stillThereTimeout != false) {
      clearTimeout(this.stillThereTimeout);
      this.stillThereTimeout = false;
    }

    gsap.to($("#still-there"), 0.5, {
      autoAlpha: 0,
      onComplete: function () {
        $("#still-there").removeClass("active");
      }
    });
  }

  /**
   * Return screen id using attribute and value
   * @param attribute
   * @param attributeValue
   * @returns {*|boolean}
   */
  findScreenIdByAttribute(attribute, attributeValue) {
    const elementFound = $(`.screen[${attribute}="${attributeValue}"]`).eq(0);

    if (elementFound.length) {
      return parseInt(elementFound.attr("id").replace("screen-", ""));
    } else {
      return false;
    }
  }

  // Kill/reset timeline before building a new one
  killTimeline(timeline) {
    if (timeline) {
      timeline.kill();
      timeline = null;
    }
  }

  // Reset values when we return to the homepage
  reset(screenId, resetCallback) {

    if (typeof screenId == "undefined") {
      screenId = 1;
    }

    this.closeStillThereModal();

    // Return to idle screen
    this.goToScreen(screenId, () => {
      resetCallback();
    }, true);

  }
}
